import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { takeReturnPath, useAuth } from '../lib/auth';

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallback,
});

// Exported so the deep-link round-trip can be asserted against the real
// component (Route.options.component) — naming the export also opts this route
// out of code-splitting, matching the other tested routes here.
export function AuthCallback() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  // AuthProvider runs handleRedirectPromise() on mount. Once it has resolved
  // and we have a user, bounce to the deep link the user originally requested
  // (stashed by RequireAuth before the Entra bounce) or /dashboard otherwise.
  // If we're still on this page after ~2s with no auth, fall back to /login.
  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated) {
      const returnTo = takeReturnPath();
      void navigate({ to: returnTo ?? '/dashboard' });
      return;
    }
    const id = setTimeout(() => {
      void navigate({ to: '/login' });
    }, 2000);
    return () => clearTimeout(id);
  }, [isAuthenticated, isLoading, navigate]);

  return (
    <div className="login-shell">
      <div className="muted" style={{ textAlign: 'center', padding: 32 }}>
        กำลังเข้าสู่ระบบ…
      </div>
    </div>
  );
}
